export default __webpack_public_path__ + "static/media/Kriska.528773a6.jpg";